module.exports = __webpack_public_path__ + "img/03.fc8f4013.jpg";